import apiRequest from '../api/api-request';
import { useFormContext } from '../Context/FormContext'


const authServices = {

    categoryList: async (data) => {
        return apiRequest({
            method:"GET",
            url: `/api/category/api/list`,
        });
    },

    companyExist: async (data) => {
        return apiRequest({
            method:"GET",
            url: `/api/compliant/exist/${data.data}`,
        });
    },

    docExist: async (data) => {
        return apiRequest({
            method:"GET",
            url: `/api/compliant/exist/doc/holder?code=${data.data}`,
        });
    },

    vesselList: async (data) => {
        return apiRequest({
            method:"GET",
            url: `/api/compliant/vessel/list?code=${data.data}`,
        });
    },

    docList: async (data) => {
        return apiRequest({
            method:"GET",
            url: `/api/compliant/vessel/list?code=${data.data}`,
        });
    },

    OTPcheck: async (data) => {
        return apiRequest({
            method:"POST",
            data: data,
            url: `/api/compliant/otp`,
            
        });
    },

    OTPverify: async (data) => {
        return apiRequest({
            method:"POST",
            data: data,
            url: `/api/compliant/verify`,
        });
    },

    Compliant: async (data) => {
        return apiRequest({
            method:"POST",
            data: data.data,
            url: `/api/compliant?code=${data.code}`,
        });
    },

    CodeFileUpload: async (data) => {
        return apiRequest({
            method:"POST",
            data: data,
            url: `/api/codeupload/upload`,
            headers: {
                "Content-Type":  "multipart/form-data"
            },
        });
    },

    NoCodeFileUpload: async (data) => {
        return apiRequest({
            method:"POST",
            data: data,
            url: `/api/s3upload/upload`,
            headers: {
                "Content-Type":  "multipart/form-data"
            },
        });
    },

    shipType: async (data) => {

        const size = data?.size ? data?.size : 100000
        const page = data?.page ? data?.size : 0

        return apiRequest({
            method:"GET",
            data: data,
            url: `/api/ship_types?size=${size}&page=${page}`,
            headers: {
                "Content-Type":  "multipart/form-data"
            },
        });
    },

    rankOnBoard: async (data) => {

        const size = data?.size ? data?.size : 100000
        const page = data?.page ? data?.size : 0

        return apiRequest({
            method:"GET",
            data: data,
            url: `/api/rankonboard?size=${size}&page=${page}`,
            headers: {
                "Content-Type":  "multipart/form-data"
            },
        });
    },
    
    complaintWithOutCode: async (data) => {
        return apiRequest({
            method:"POST",
            data: data.data,
            url: `/api/public`
        });
    },

    survey: async (data) => {
        return apiRequest({
            method:"POST",
            data: data.data,
            url: `/api/public/survey`
        });
    },


}

export default authServices